var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "939.1px",
    height: "301.9px",
    viewBox: "0 0 939.1 301.9",
    style: {
      enableBackground: "new 0 0 939.1 301.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Sombra{fill:none;}\n\t.Cantos_x0020_arredondados_x0020__x002D__x0020_2_x0020_pontos{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Reflexo_x0020_X_x0020_em_x0020_tempo_x0020_real{fill:none;}\n\t.Chanfro_x0020_suave{fill:url(#SVGID_1_);}\n\t.Anoitecer{fill:#FFFFFF;}\n\t.Foliage_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#51AEE2;}\n\t.st0{fill:#575756;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#006198;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#048DC2;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#9A1915;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E20E17;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#F18700;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FECA05;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.9232,
    y1: -268.6076,
    x2: 172.6303,
    y2: -267.9005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    style: {
      stopColor: "#E2E2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5D4D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5323,
    style: {
      stopColor: "#C0BFC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#A4A2A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B6E6E"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M535.8,166h16.7v89.5c-21.5,20.5-52.6,30.8-85.4,30.8c-72.1,0-125.1-51.6-125.1-121.3 c0-69.7,53-121.3,125.4-121.3c34.5,0,64.9,10.9,86.1,32.8L542.7,88c-20.8-20.5-45.8-28.4-74.8-28.4 c-62.2,0-108.3,45.1-108.3,105.3c0,59.8,46.1,105.3,108.3,105.3c25.3,0,48.5-6.2,68-21.9V166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.2,49.1c0-7.5,6.2-14,14-14c7.9,0,14,6.2,14,13.7c0,7.9-6.2,14-14,14C601.4,62.8,595.2,56.6,595.2,49.1z  M600.7,106.2h17.1v178.4h-17.1V106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M820.8,199.5H667.4c1.7,42.4,32.8,71.1,75.5,71.1c22.6,0,43.4-8.2,57.1-24.9l9.9,11.3 c-15.7,19.1-40.3,29-67.3,29c-54,0-91.9-37.6-91.9-90.6c0-53,36.6-90.6,85.4-90.6c48.9,0,85.1,36.9,85.1,89.9 C821.2,196,820.8,197.7,820.8,199.5z M667.7,186.1h136.7c-2.4-38.6-30.4-66.3-68.3-66.3C698.1,119.8,670.5,147.2,667.7,186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M939.1,104.8v16.7c-1.4,0-2.7-0.3-4.1-0.3c-39.6,0-63.2,26.3-63.2,70.4v93h-17.1V106.2h16.4v39 C882,119.1,905.6,104.8,939.1,104.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 467.7,
    y: 162.1,
    className: "st0",
    width: 84.4,
    height: 17.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.9,248l9.3,11.7c-8.4,4.9,31.2,15.7,46.1,7.1l37.9-21.9c9.7-5.6,9-15.1,0.2-20.2l-41.6-24 c-10.1-5.8-18.5-5.6-28-0.1l-12.1,7c-17.1,9.9-23.8,13.5-40.7,23.7L159.9,248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.4,284.5c0,0-2.5,1.4-14.3,8.3c-12.6,7.3-36.1,15.6-59.6,1.6c-2.7-1.6-5.5-3.3-8.2-4.9l-6.4-3.3l0,0l0,0 l-34-19.6l-4.1-2.4l-32.5-18.7c-9.5-5.5-11.7-14.7,0.3-21.6l44.1-25.5c6.6-3.8,14.9-3,22.6,1.4l57.4,33.1l21.8,12.6 c17.2,9.9,36.2,20.6,56.9,14.2c0,0-2.5,1.4-14.3,8.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.1,82.9l5.5-13.9c8.4,4.9-2-34.8-16.9-43.4L160.8,3.7c-9.7-5.6-17.6-0.3-17.6,9.9l0,48 c0,11.6,4.4,18.8,13.9,24.3l12.1,7c17.1,9.9,23.6,13.9,40.9,23.4L210.1,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.9,44.2c0,0,2.5,1.4,14.3,8.3c12.6,7.3,31.5,23.5,31.2,50.9c0,3.2-0.1,6.4-0.1,9.5l0.3,7.2l0,0l0,0l0,39.3 l0,4.7l0,37.5c0,11-6.8,17.5-18.9,10.5l-44.1-25.5c-6.6-3.8-10.1-11.4-10.1-20.3l0-66.3l0-25.1c0-19.8-0.2-41.7-16.2-56.4 c0,0,2.5,1.4,14.3,8.3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.9,118.8l-14.8,2.2c0-9.7-29.2,19.2-29.2,36.3L0,201c0,11.2,8.6,15.3,17.4,10.2l41.6-24 c10.1-5.8,14.1-13.3,14.1-24.2v-14c0-19.7,0.2-27.4-0.2-47.1L43.9,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.5,121c0,0,0-2.9,0-16.5c0-14.6,4.6-39,28.4-52.4c2.8-1.6,5.6-3.1,8.3-4.6l6.1-3.9l0,0h0l34-19.7l4.1-2.4 l32.4-18.8c9.5-5.5,18.5-2.8,18.5,11.1v51c0,7.6-4.8,14.5-12.5,18.9l-57.4,33.1l-21.8,12.6c-17.2,9.9-36,21-40.7,42.2 c0,0,0-2.9,0-16.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGier);
export default __webpack_public_path__ + "static/media/logo_gier.383fee67af2c456d94c43726d17dae26.svg";
export { ForwardRef as ReactComponent };